import React from 'react';
import { sanitize } from 'helpers/utils/htmlSanitize';
import Typography from 'components/commercetools-ui/atoms/typography';
import Accordion from 'components/commercetools-ui/atoms/accordion';

import { GenericSectionContent, FAQItem } from '../../types';
import { useAdditionalCss } from '../../../helpers/useAdditionalCss';
import styles from './index.module.css';

export default function FAQsRendering({ content }: { content: GenericSectionContent }) {
  const { faqs, title, additional_css, additional_css_class_names } = content;

  const { uniqueClass, scopedAdditionalCss } = useAdditionalCss(additional_css, 'FAQsRendering');

  return (
    <>
      {scopedAdditionalCss && <style dangerouslySetInnerHTML={{ __html: scopedAdditionalCss }} />}
      <div
        id="faq-section"
        className={`relative mx-auto w-full px-24 pt-24 pb-24 md:px-28 lg:px-48 lg:pt-40 lg:pb-40 xl:px-60 2xl:px-80 2xl:pt-60 2xl:pb-60 ${[additional_css_class_names, uniqueClass].filter(Boolean).join(' ')}`}
      >
        {title && (
          <Typography className="!font-semibold text-primary-black border-b border-neutral-400 pb-1 text-2xl !leading-[2.375rem] sm:!leading-[3.5rem] lg:border-none">
            {title}
          </Typography>
        )}
        {faqs?.map((faq: FAQItem, index: number) => (
          <Accordion
            key={index}
            headingTag="h3"
            closedSectionTitle={faq?.question}
            className="rounded-md border-neutral-300 border-b border-neutral-400"
            buttonClassName="!px-0 !py-4 text-left text-[19px] font-normal leading-8 text-[#333]"
            panelClassName="pl-16 pr-4 pb-6 pt-[6px]"
          >
            {faq?.answer && (
              <div dangerouslySetInnerHTML={{ __html: sanitize(faq.answer) }} />
            )}
          </Accordion>
        ))}
      </div>
    </>
  );
}
